import { Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { useUnsubscribeMember } from "./queries"
import { useEventId } from "pages/events"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}

const UnsubscribeMemberModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const { mutate, isLoading } = useUnsubscribeMember(eventId!, {
    meta: {
      type: "unsubscribe",
      context: "male",
      count: 1,
      entity: t("members.member"),
    },
  })
  const onConfirm = () => {
    mutate(data!, {
      onSuccess() {
        props.onClose()
      },
    })
  }

  return (
    <Modal
      okType="danger"
      okText={t("global.delete")}
      onCancel={props.onClose}
      onOk={onConfirm}
      confirmLoading={isLoading}
      cancelText={t("global.cancel")}
      {...props}
    >
      <p style={{ marginTop: "var(--size-6)" }}>
        {t("global.delete_confirmation")}
      </p>
    </Modal>
  )
}

export default UnsubscribeMemberModal
